module.exports = __webpack_public_path__ + "img/symbol_0.3aa12a9d.png";